export default __webpack_public_path__ + "static/media/health-back.0c308df4.jpg";